import React from 'react';
import { useQuery } from '@apollo/client';
import { useBexApi } from '@shared-ui/bex-api-context';
import { useLogger } from '@shared-ui/logger-context';
import { useProvidedState } from '@shared-ui/provided-state-context';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            }
            catch (e) {
                reject(e);
            }
        }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function () {
            if (t[0] & 1)
                throw t[1];
            return t[1];
        }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m)
        return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
    }
    catch (error) {
        e = { error: error };
    }
    finally {
        try {
            if (r && !r.done && (m = i["return"]))
                m.call(i);
        }
        finally {
            if (e)
                throw e.error;
        }
    }
    return ar;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages.
 */
var AlterMode;
(function (AlterMode) {
    AlterMode["DEBUG"] = "DEBUG";
    AlterMode["NONE"] = "NONE";
    AlterMode["PREVIEW"] = "PREVIEW";
    AlterMode["RELEASED"] = "RELEASED";
})(AlterMode || (AlterMode = {}));
var AuthenticationState;
(function (AuthenticationState) {
    AuthenticationState["ANONYMOUS"] = "ANONYMOUS";
    AuthenticationState["AUTHENTICATED"] = "AUTHENTICATED";
    AuthenticationState["IDENTIFIED"] = "IDENTIFIED";
})(AuthenticationState || (AuthenticationState = {}));
/**
 * Supported capabilities of chatbot VAC.
 */
var ChatbotCapabilities;
(function (ChatbotCapabilities) {
    ChatbotCapabilities["CLICKSTREAM"] = "CLICKSTREAM";
    ChatbotCapabilities["GLASSBOX"] = "GLASSBOX";
})(ChatbotCapabilities || (ChatbotCapabilities = {}));
/**
 * Supported versions of chatbot.
 */
var ChatbotVersionId;
(function (ChatbotVersionId) {
    ChatbotVersionId["V1"] = "V1";
    ChatbotVersionId["V2"] = "V2";
})(ChatbotVersionId || (ChatbotVersionId = {}));
/**
 * Valid device types
 */
var DeviceType;
(function (DeviceType) {
    DeviceType["APP_PHONE"] = "APP_PHONE";
    DeviceType["APP_TABLET"] = "APP_TABLET";
    DeviceType["CHAT_APP"] = "CHAT_APP";
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MOBILE_PHONE"] = "MOBILE_PHONE";
    DeviceType["MOBILE_TABLET"] = "MOBILE_TABLET";
    DeviceType["VOICE_APP"] = "VOICE_APP";
})(DeviceType || (DeviceType = {}));
/**
 * Privacy tracking user preference. We can retrieve info on if the site allows
 * tracking from Site Info and null can also be used to represent a selection or not
 */
var PrivacyTrackingState;
(function (PrivacyTrackingState) {
    PrivacyTrackingState["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
    PrivacyTrackingState["CAN_TRACK"] = "CAN_TRACK";
})(PrivacyTrackingState || (PrivacyTrackingState = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

function getChatClientFromDOM(authToken) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (typeof window !== 'undefined') {
                if (window === null || window === void 0 ? void 0 : window.virtualAgentControl) {
                    return [2 /*return*/, window.virtualAgentControl];
                }
                if (window === null || window === void 0 ? void 0 : window.VacClientAdapter) {
                    return [2 /*return*/, window.VacClientAdapter.getInstance(authToken)];
                }
            }
            return [2 /*return*/, undefined];
        });
    });
}
function getInitedChatClientFromDOM() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var _b, isInit, chatInstance;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(typeof window !== 'undefined')) return [3 /*break*/, 6];
                    _b = (window === null || window === void 0 ? void 0 : window.virtualAgentControl);
                    if (!_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, window.virtualAgentControl.isInitialized];
                case 1:
                    _b = (_c.sent());
                    _c.label = 2;
                case 2:
                    if (_b) {
                        return [2 /*return*/, window.virtualAgentControl];
                    }
                    if (!(((_a = window === null || window === void 0 ? void 0 : window.VirtualAgentControl) === null || _a === void 0 ? void 0 : _a.initialized) && (window === null || window === void 0 ? void 0 : window.VacClientAdapter))) return [3 /*break*/, 6];
                    return [4 /*yield*/, window.VirtualAgentControl.initialized];
                case 3:
                    isInit = _c.sent();
                    if (!isInit) return [3 /*break*/, 6];
                    return [4 /*yield*/, window.VacClientAdapter.getInstance()];
                case 4:
                    chatInstance = _c.sent();
                    return [4 /*yield*/, chatInstance.isInitialized];
                case 5:
                    if (_c.sent()) {
                        return [2 /*return*/, chatInstance];
                    }
                    _c.label = 6;
                case 6: return [2 /*return*/, undefined];
            }
        });
    });
}
function makeScript(javascriptUrl, onScriptLoad, onScriptLoadError) {
    var script = document.createElement('script');
    script.src = javascriptUrl;
    script.onload = onScriptLoad;
    script.onerror = onScriptLoadError;
    return script;
}
function adaptAuthToken(authToken) {
    if (typeof window.atob === 'function') {
        var decoded = window.atob(authToken);
        var json = JSON.parse(decoded);
        return json;
    }
    return undefined;
}
function adaptChatbotCapabilities(capabilities) {
    var adaptedCapabilities = capabilities.map(function (capability) {
        switch (capability) {
            case ChatbotCapabilities.CLICKSTREAM: {
                return 'Clickstream';
            }
            case ChatbotCapabilities.GLASSBOX: {
                return 'Glassbox';
            }
            default: {
                return '';
            }
        }
    });
    return adaptedCapabilities.filter(function (value) { return value !== ''; });
}
function adaptChatbotConfig(chatbotConfig, pageName, locale, authTokenForInit, clientOverrides) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    var adaptedConfigs = {
        authToken: authTokenForInit,
        channelOriginId: (clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.channelOriginId) || chatbotConfig.channelOriginId,
        capabilities: chatbotConfig.chatbotCapabilities ? adaptChatbotCapabilities(chatbotConfig.chatbotCapabilities) : [],
        containerElement: clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.containerElement,
        conversationProperties: {
            launchPoint: ((_a = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _a === void 0 ? void 0 : _a.launchPoint) || chatbotConfig.conversationProperties.launchPoint,
            traceId: chatbotConfig.conversationProperties.traceId,
            pageName: pageName
        },
        embedded: clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.embedded,
        enableAutoOpenChatWidget: (clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.enableAutoOpenChatWidget) || chatbotConfig.enableAutoOpenChatWidget,
        enableProactiveConversation: (clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.enableProactiveConversation) || chatbotConfig.enableProactiveConversation,
        fastRender: chatbotConfig.version.versionId === ChatbotVersionId.V2,
        intentMessage: clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.intentMessage,
        languageId: (clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.languageId) || locale,
        subscribedEvents: clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.subscribedEvents,
        eventHandler: clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.eventHandler,
        userProperties: clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.userProperties,
        configurationOverrides: clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.configurationOverrides
    };
    if ((_b = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _b === void 0 ? void 0 : _b.skipWelcome) {
        adaptedConfigs.conversationProperties.skipWelcome = (_c = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _c === void 0 ? void 0 : _c.skipWelcome;
    }
    if ((_d = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _d === void 0 ? void 0 : _d.listingId) {
        adaptedConfigs.conversationProperties.listingId = (_e = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _e === void 0 ? void 0 : _e.listingId;
    }
    if ((_f = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _f === void 0 ? void 0 : _f.checkin) {
        adaptedConfigs.conversationProperties.checkin = (_g = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _g === void 0 ? void 0 : _g.checkin;
    }
    if ((_h = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _h === void 0 ? void 0 : _h.checkout) {
        adaptedConfigs.conversationProperties.checkout = (_j = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _j === void 0 ? void 0 : _j.checkout;
    }
    if ((_k = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _k === void 0 ? void 0 : _k.adults) {
        adaptedConfigs.conversationProperties.adults = (_l = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _l === void 0 ? void 0 : _l.adults;
    }
    if ((_m = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _m === void 0 ? void 0 : _m.children) {
        adaptedConfigs.conversationProperties.children = (_o = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _o === void 0 ? void 0 : _o.children;
    }
    if ((_p = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _p === void 0 ? void 0 : _p.pets) {
        adaptedConfigs.conversationProperties.pets = (_q = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _q === void 0 ? void 0 : _q.pets;
    }
    if ((_r = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _r === void 0 ? void 0 : _r.currency) {
        adaptedConfigs.conversationProperties.currency = (_s = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _s === void 0 ? void 0 : _s.currency;
    }
    if ((_t = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _t === void 0 ? void 0 : _t.device) {
        adaptedConfigs.conversationProperties.device = (_u = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _u === void 0 ? void 0 : _u.device;
    }
    if ((_v = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _v === void 0 ? void 0 : _v.bookNow) {
        adaptedConfigs.conversationProperties.bookNow = (_w = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _w === void 0 ? void 0 : _w.bookNow;
    }
    if ((_x = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _x === void 0 ? void 0 : _x.havId) {
        adaptedConfigs.conversationProperties.havId = (_y = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _y === void 0 ? void 0 : _y.havId;
    }
    if ((_z = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _z === void 0 ? void 0 : _z.site) {
        adaptedConfigs.conversationProperties.site = (_0 = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _0 === void 0 ? void 0 : _0.site;
    }
    if ((_1 = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _1 === void 0 ? void 0 : _1.hostname) {
        adaptedConfigs.conversationProperties.hostname = (_2 = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _2 === void 0 ? void 0 : _2.hostname;
    }
    if ((_3 = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _3 === void 0 ? void 0 : _3.chatbotName) {
        adaptedConfigs.conversationProperties.chatbotName = (_4 = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _4 === void 0 ? void 0 : _4.chatbotName;
    }
    if ((_5 = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _5 === void 0 ? void 0 : _5.chatbotEntryPoint) {
        adaptedConfigs.conversationProperties.chatbotEntryPoint = (_6 = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _6 === void 0 ? void 0 : _6.chatbotEntryPoint;
    }
    // Need all three for 'chatback'
    if ((clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationId) && (clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.participantId) && (clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.mode)) {
        adaptedConfigs.conversationId = clientOverrides.conversationId;
        adaptedConfigs.participantId = clientOverrides.participantId;
        adaptedConfigs.mode = clientOverrides.mode;
    }
    return adaptedConfigs;
}
function isVacInitialized() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInitedChatClientFromDOM()];
                case 1: return [2 /*return*/, (_a.sent()) !== undefined];
            }
        });
    });
}
function isVirtualAgentControlClientLegacy(virtualAgentControlClient) {
    return virtualAgentControlClient.iframeManager !== undefined && virtualAgentControlClient.vacFrame === undefined;
}
function setVacFrameVisibilityHidden(hidden) {
    return __awaiter(this, void 0, void 0, function () {
        var initedClient, active;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInitedChatClientFromDOM()];
                case 1:
                    initedClient = _a.sent();
                    active = !hidden;
                    if (initedClient) {
                        if (isVirtualAgentControlClientLegacy(initedClient)) {
                            initedClient.iframeManager.iframe.hidden = hidden;
                        }
                        else {
                            initedClient.vacFrame.setFrameActive(active);
                        }
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
            }
        });
    });
}
function openChatWidget() {
    return __awaiter(this, void 0, void 0, function () {
        var initedClient;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInitedChatClientFromDOM()];
                case 1:
                    initedClient = _a.sent();
                    if (initedClient) {
                        initedClient.openChatWidget();
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function setConversationContext(clientOverrides) {
    return __awaiter(this, void 0, void 0, function () {
        var initedClient, _a, intentMessage, conversationProperties, silent;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getInitedChatClientFromDOM()];
                case 1:
                    initedClient = _b.sent();
                    _a = clientOverrides || {}, intentMessage = _a.intentMessage, conversationProperties = _a.conversationProperties, silent = _a.silent;
                    if (initedClient && (intentMessage || conversationProperties)) {
                        initedClient.setConversationContext({
                            intentMessage: intentMessage,
                            conversationProperties: conversationProperties
                        }, silent);
                    }
                    return [2 /*return*/];
            }
        });
    });
}

var addEventHandler = function (virtualAgentClient, subscribedEvents, eventHandler, localData) {
    var _a;
    if (virtualAgentClient && subscribedEvents && eventHandler && ((_a = localData === null || localData === void 0 ? void 0 : localData.localChatClientState) === null || _a === void 0 ? void 0 : _a.isEventHandlerRegistered) === false) {
        virtualAgentClient.on(subscribedEvents, eventHandler);
    }
};
var removeEventHandler = function (query, client, virtualAgentClient, subscribedEvents, eventHandler, localData) {
    if (virtualAgentClient && localData && subscribedEvents && eventHandler) {
        virtualAgentClient.off(subscribedEvents, eventHandler);
        client.writeQuery({
            query: query,
            data: {
                localChatClientState: __assign(__assign({}, localData.localChatClientState), { isEventHandlerRegistered: false })
            }
        });
    }
};

var VirtualAgentStateEvent;
(function (VirtualAgentStateEvent) {
    VirtualAgentStateEvent["VirtualAgentInitialized"] = "virtualAgentInitialized";
    VirtualAgentStateEvent["VirtualAgentIntentMessage"] = "virtualAgentIntentMessage";
})(VirtualAgentStateEvent || (VirtualAgentStateEvent = {}));
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["update"] }] */
var VirtualAgentControlState = /** @class */ (function () {
    function VirtualAgentControlState() {
        this.data = { isInitialized: false };
        this.stateFieldName = 'virtualAgentControlState';
        this.events = [VirtualAgentStateEvent.VirtualAgentInitialized, VirtualAgentStateEvent.VirtualAgentIntentMessage];
    }
    VirtualAgentControlState.prototype.update = function (event, currentState, payload) {
        if (event === VirtualAgentStateEvent.VirtualAgentInitialized) {
            return Object.assign({}, currentState, { isInitialized: true });
        }
        if (event === VirtualAgentStateEvent.VirtualAgentIntentMessage && (payload === null || payload === void 0 ? void 0 : payload.data) && payload.data.intent) {
            return Object.assign({}, currentState, { intentMessage: payload.data });
        }
        return currentState;
    };
    return VirtualAgentControlState;
}());

var __Query = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "ChatbotConfigQuery" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ContextInput" } } }, "defaultValue": undefined, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "applicationName" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, "defaultValue": undefined, "directives": [] }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "chatbotConfig" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "context" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "applicationName" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "applicationName" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "authToken" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "channelOriginId" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "chatbotCapabilities" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "conversationProperties" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "launchPoint" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "traceId" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "enableAutoOpenChatWidget" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "enableProactiveConversation" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "version" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "javascriptUrl" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "versionId" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }] } }], "loc": { "start": 0, "end": 462, "source": { "body": "\n  query ChatbotConfigQuery($context: ContextInput!, $applicationName: String!) {\n    chatbotConfig(context: $context, applicationName: $applicationName) {\n      authToken\n      channelOriginId\n      chatbotCapabilities\n      conversationProperties {\n        launchPoint\n        traceId\n      }\n      enableAutoOpenChatWidget\n      enableProactiveConversation\n      version {\n        javascriptUrl {\n          value\n        }\n        versionId\n      }\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
// Storing 'requested' in ApolloClient state avoids extra work on soft page transitions
var __localState = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "localChatClient" }, "variableDefinitions": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "localChatClientState" }, "arguments": [], "directives": [{ "kind": "Directive", "name": { "kind": "Name", "value": "client" }, "arguments": [] }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "requested" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "isEventHandlerRegistered" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }], "loc": { "start": 0, "end": 119, "source": { "body": "\n  query localChatClient {\n    localChatClientState @client {\n      requested\n      isEventHandlerRegistered\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var defaultLocalState = {
    __typename: 'LocalChatClientState',
    requested: false
};
var LogEvent;
(function (LogEvent) {
    LogEvent["STRATBOT_VAC_INIT_NO_VALID_CHAT_CLIENT_FOUND"] = "STRATBOT_VAC_INIT_NO_VALID_CHAT_CLIENT_FOUND";
    LogEvent["STRATBOT_VAC_SCRIPT_FAILED_TO_LOAD"] = "STRATBOT_VAC_SCRIPT_FAILED_TO_LOAD";
    LogEvent["STRATBOT_VAC_ERROR_GETTING_INSTANCE_TO_INIT"] = "STRATBOT_VAC_ERROR_GETTING_INSTANCE_TO_INIT";
    LogEvent["STRATBOT_VAC_FAILED_TO_FIND_INSTANCE_TO_INIT"] = "STRATBOT_VAC_FAILED_TO_FIND_INSTANCE_TO_INIT";
    LogEvent["STRATBOT_VAC_INIT_SUCCEEDED"] = "STRATBOT_VAC_INIT_SUCCEEDED";
    LogEvent["STRATBOT_VAC_INIT_FAILED"] = "STRATBOT_VAC_INIT_FAILED";
})(LogEvent || (LogEvent = {}));
var VirtualAgentControl = function (props) {
    var _a, _b, _c;
    var applicationName = props.applicationName, clientOverrides = props.clientOverrides, pageName = props.pageName, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var _d = useLogger(), logError = _d.error, logInfo = _d.info;
    var locale = context.locale;
    var variables = {
        context: context,
        applicationName: applicationName
    };
    var _e = __read(React.useState(), 2), virtualAgentClient = _e[0], setVirtualAgentClient = _e[1];
    var _f = __read(React.useState(false), 2), isInitilizing = _f[0], setIsInitilizing = _f[1];
    var _g = __read(useProvidedState(), 2), dispatch = _g[1];
    var skipQuery = Boolean(virtualAgentClient);
    var data = useQuery(__Query, { variables: variables, ssr: !skipSsr, skip: skipQuery }).data;
    var _h = useQuery(__localState, { ssr: !skipSsr }), localData = _h.data, client = _h.client;
    var dispatchInitialized = function () {
        dispatch({ type: VirtualAgentStateEvent.VirtualAgentInitialized });
    };
    var onScriptLoadError = function () { return logError(LogEvent.STRATBOT_VAC_SCRIPT_FAILED_TO_LOAD); };
    React.useEffect(function () {
        if (!virtualAgentClient) {
            if ((data === null || data === void 0 ? void 0 : data.chatbotConfig) && (!localData || !localData.localChatClientState.requested) && !isInitilizing) {
                setIsInitilizing(true);
                client.writeQuery({
                    query: __localState,
                    data: __assign(__assign({}, (data || {})), { localChatClientState: __assign(__assign({}, defaultLocalState), { requested: true, isEventHandlerRegistered: true }) })
                });
                var chatbotConfig = data.chatbotConfig, javascriptUrl = data.chatbotConfig.version.javascriptUrl;
                var authToken_1 = (clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.authToken) || adaptAuthToken(chatbotConfig.authToken);
                var clientConfig_1 = adaptChatbotConfig(chatbotConfig, pageName, locale, authToken_1, clientOverrides);
                var onScriptLoad = function () {
                    getChatClientFromDOM(authToken_1)
                        .then(function (chatClientFromDOM) {
                        if (chatClientFromDOM) {
                            chatClientFromDOM
                                .initialize(clientConfig_1)
                                .then(function () {
                                getInitedChatClientFromDOM().then(function (instance) {
                                    if (instance) {
                                        setVirtualAgentClient(instance);
                                        dispatchInitialized();
                                        logInfo(LogEvent.STRATBOT_VAC_INIT_SUCCEEDED);
                                    }
                                    else {
                                        logError(LogEvent.STRATBOT_VAC_INIT_NO_VALID_CHAT_CLIENT_FOUND);
                                    }
                                });
                            })
                                .catch(function (error) {
                                logError(LogEvent.STRATBOT_VAC_INIT_FAILED, error);
                            });
                        }
                        else {
                            logError(LogEvent.STRATBOT_VAC_FAILED_TO_FIND_INSTANCE_TO_INIT);
                        }
                    })
                        .catch(function (error) {
                        logError(LogEvent.STRATBOT_VAC_ERROR_GETTING_INSTANCE_TO_INIT, error);
                    });
                };
                document.head.appendChild(makeScript(javascriptUrl.value, onScriptLoad, onScriptLoadError));
            }
            else {
                getInitedChatClientFromDOM().then(function (instance) {
                    if (instance) {
                        setVirtualAgentClient(instance);
                        dispatchInitialized();
                    }
                });
            }
        }
    }, [
        virtualAgentClient,
        data,
        localData,
        isInitilizing,
        client,
        pageName,
        locale,
        clientOverrides,
        dispatchInitialized,
        logError,
        logInfo,
        onScriptLoadError
    ]);
    React.useEffect(function () {
        var _a = clientOverrides || {}, intentMessage = _a.intentMessage, conversationProperties = _a.conversationProperties, silent = _a.silent;
        if (virtualAgentClient && (intentMessage || conversationProperties)) {
            var extendedConversationProperties = Object.assign(conversationProperties || {}, { pageName: pageName });
            virtualAgentClient.setConversationContext({
                intentMessage: intentMessage,
                conversationProperties: extendedConversationProperties
            }, silent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (_a = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.intentMessage) === null || _a === void 0 ? void 0 : _a.intent,
        (_b = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _b === void 0 ? void 0 : _b.launchPoint,
        (_c = clientOverrides === null || clientOverrides === void 0 ? void 0 : clientOverrides.conversationProperties) === null || _c === void 0 ? void 0 : _c.skipWelcome
    ]);
    var _j = clientOverrides || {}, subscribedEvents = _j.subscribedEvents, eventHandler = _j.eventHandler;
    var eventHandlerMemo = React.useMemo(function () {
        return eventHandler;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    /* As VAC/Stratbot is initialised only once with the provided eventHandler/subscribedEvents &
       is unable to update/use new event handler. So with this implementation we are
       able to register new eventHandler/subscribedEvents when ever they change.
    */
    React.useEffect(function () {
        addEventHandler(virtualAgentClient, subscribedEvents, eventHandlerMemo, localData);
        return function () {
            removeEventHandler(__localState, client, virtualAgentClient, subscribedEvents, eventHandlerMemo, localData);
        };
    }, [virtualAgentClient, subscribedEvents, eventHandlerMemo, localData, client]);
    return null;
};
VirtualAgentControl.displayName = 'VirtualAgentControl';

export { VirtualAgentControl, VirtualAgentControlState, VirtualAgentStateEvent, isVacInitialized, openChatWidget, setConversationContext, setVacFrameVisibilityHidden };
